import { isEmbarcacaoTanquesEmpty } from "@/modules/embarcacoes/embarcacoes.types";
import type {
  EmbarcacaoTanques,
  EmbarcacaoTanquesState,
} from "@/modules/embarcacoes/embarcacoes.types";
import {
  useEmbarcacaoDetailSection,
  type EmbarcacaoDetailSectionQuery,
} from "./use-embarcacao-detail-section";

const TANQUES_QUERY: EmbarcacaoDetailSectionQuery<EmbarcacaoTanques> = {
  select: (ficha) => ficha.tanques,
  isEmpty: isEmbarcacaoTanquesEmpty,
  secao: "os Tanques",
};

interface UseEmbarcacaoTanquesResult extends EmbarcacaoTanquesState {
  reload: () => void;
}

/**
 * Consulta os Tanques da embarcação pedida (AC4). Somente leitura: nenhuma
 * escrita é disparada na abertura nem no fechamento do modal.
 */
export function useEmbarcacaoTanques(id: string): UseEmbarcacaoTanquesResult {
  const { data, ...state } = useEmbarcacaoDetailSection(id, TANQUES_QUERY);

  return { ...state, tanques: data };
}
